'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobErrorMessage', cobErrorMessage);

	cobErrorMessage.$inject = ['subjectObserverMessagesService', 'observerService', 'authenticationService', '$state', '$location', '$window'];

	var subjectObserverMessagesService, observerService, subjectMessages, observerMessages, authenticationService, $state, $location, $window;

	function cobErrorMessage(_subjectObserverMessagesService_, _observerService_, _authenticationService_, _state_, _$location_, _$window_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		authenticationService = _authenticationService_;
		$state = _state_;
		$location = _$location_;
		$window = _$window_;


		return {
			scope: {},
			//templateUrl:
			//    '<div ng-cloak ng-show="errorMessage != \'\'" style="color: red; font-weight: bold; padding: 10px 0 0 10px;"><span ng-click="errorMessage=\'\'">[Clear Error]</span><div ng-hide="hideError" ng-bind-html="errorMessage">{{errorMessage}}</div></div>',
			templateUrl: '/app/common/directives/error-message.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope, elem, attrs) {

		scope.errorMessage = '';
		scope.clearMessage = clearMessage;


		activate();

		///////////////////////////////////////////

		function activate() {
			scope.closeModal = closeModal;

			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			registerObserverHandlers();
		}

		function registerObserverHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_HTTP_ERROR_500, handler: onGenericError },
					{ message: observerMessages.COB_OBSERVER_HTTP_ERROR_401, handler: onUnauthorizedError },
					{ message: observerMessages.COB_OBSERVER_HTTP_ERROR_404, handler: on404Error }
				]);
		}

		function onGenericError(data) {
			scope.errorMessage = 500;
		}

		function clearMessage() {
			scope.errorMessage = '';
		}

		function on404Error() {
			$state.go('urlnotfound');
		}

		function onUnauthorizedError(data) {
			scope.errorMessage = 401;
			authenticationService.logout();
		}

		function closeModal() {
			$window.location.replace('/login');
			scope.errorMessage = '';
		}
	}
})();
